import { storage } from "@/lib/storage";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const day = (d) => new Date(d).toISOString().slice(0, 10);

// Compact sales summary from this device's offline records
export const buildContext = () => {
  const txs = storage.getTransactions();
  const profile = storage.getProfile();
  if (!txs.length) return `Merchant: ${profile?.name || "Merchant"}. No transactions yet.`;
  const today = day(new Date());
  const sum = (list) => {
    const out = {};
    list.forEach((t) => {
      const k = `${t.direction || "received"}|${t.method || "other"}|${t.currency || "INR"}`;
      out[k] = out[k] || { n: 0, amt: 0 };
      out[k].n += 1;
      out[k].amt += Number(t.amount || 0);
    });
    return Object.entries(out)
      .map(([k, v]) => `${k.replace(/\|/g, " / ")}: ${v.amt.toFixed(2)} (${v.n} txns)`)
      .join("; ");
  };
  const byDay = {};
  txs.forEach((t) => {
    const d = day(t.createdAt);
    byDay[d] = (byDay[d] || 0) + (t.direction === "sent" ? 0 : Number(t.amount || 0));
  });
  const recent = txs
    .slice(0, 60)
    .map((t) => `${t.createdAt.slice(0, 16)} ${t.direction} ${t.method} ${t.amount} ${t.currency}${t.note ? ` "${String(t.note).slice(0, 40)}"` : ""}`)
    .join("\n");
  return [
    `Merchant: ${profile?.name || "Merchant"}. Today's date: ${today}. Total records: ${txs.length}.`,
    `TODAY totals (direction / method / currency): ${sum(txs.filter((t) => day(t.createdAt) === today)) || "none"}`,
    `ALL-TIME totals: ${sum(txs)}`,
    `Received per day (last 30 days): ${Object.entries(byDay).slice(0, 30).map(([d, a]) => `${d}=${a.toFixed(2)}`).join(", ")}`,
    `Latest records:\n${recent}`,
  ].join("\n").slice(0, 19000);
};

export const aiApi = {
  async history(sessionId) {
    const res = await fetch(`${API}/ai/history/${sessionId}`, { credentials: "include" });
    if (!res.ok) throw new Error("history failed");
    return (await res.json()).messages;
  },
  async stream({ sessionId, message, onDelta }) {
    const res = await fetch(`${API}/ai/chat`, {
      method: "POST",
      credentials: "include",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ session_id: sessionId, message, context: buildContext() }),
    });
    if (!res.ok) {
      const msgs = { 401: "Please sign in again.", 429: "AI limit reached (30 per hour). Please try again later." };
      throw new Error(msgs[res.status] || "AI is unavailable.");
    }
    const reader = res.body.getReader();
    const dec = new TextDecoder();
    let buf = "";
    for (;;) {
      const { value, done } = await reader.read();
      if (done) break;
      buf += dec.decode(value, { stream: true });
      const events = buf.split("\n\n");
      buf = events.pop();
      for (const ev of events) {
        const line = ev.replace(/^data: /, "");
        if (line === "[DONE]") return;
        const data = JSON.parse(line);
        if (data.error) throw new Error(data.error);
        if (data.delta) onDelta(data.delta);
      }
    }
  },
};
